<template>
  <div class="coindetail">
    <XR-head titleText="交易明细" :rightShow="false"></XR-head>
    <div class="detail-traceAmt" v-if="!loaded">
        <span class="amt">{{streamDetailInfo.PlusMinus+streamDetailInfo.Trace_Amt.toFixed(2)}}</span>
    </div>
    <div class="row-list" v-if="!loaded">                      
      <div class="row-item">
          <p class="item-title">交易单号</p>
          <p class="item-value">{{streamDetailInfo.TraceNo}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">交易类型</p>
          <p class="item-value">{{streamDetailInfo.TraceName}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">交易时间</p>
          <p class="item-value">{{streamDetailInfo.CreateTimeName}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">备注</p>
          <p class="item-value">{{streamDetailInfo.Description}}</p>
      </div>
    </div>
    <XR-toast  ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {
        loaded:true,        
        streamDetailInfo :{
            CreateTime:"",
            CreateTimeName:'',
            Description:"",
            InOrOut:0,
            PlusMinus:"-",
            TraceNo:"",
            TraceNoName:'',
            TraceType:"",
            TraceTypeName:"",
            Trace_Amt:0
        }
    };
  },
  mounted: function(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    this.$refs.XRtoast.load()
    if(this.$route.query.traceNo){
        this.getDetailInfo()
    }
  },
  methods: {
    getDetailInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetCoinStreamDetail",
        JSON.stringify({'traceNo': ths.$route.query.traceNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.$refs.XRtoast.hide()
          ths.streamDetailInfo = res.Data;
          ths.loaded= false
        }
      });
    }
  }
};
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
#app .coindetail{
    background: white;
}
.coindetail .detail-traceAmt {
    overflow:hidden;
    text-align:center;
    margin: 0 20px;
    border-bottom:1px solid #efefef;
    padding:35px 0 35px;
}
    .coindetail .detail-traceAmt .amt {
        font-size:30px;
    }
    .coindetail .detail-traceAmt .unit {
        font-size:12px;
        color:#aaa;
    }
.coindetail .row-list {
    margin: 0 20px;
    padding:30px 0;
}
   .coindetail  .row-list .row-item {
        padding:10px 0;
    }
      .coindetail   .row-list .row-item .item-title {
            color:#ccc;
            font-size:16px;
        }
       .coindetail  .row-list .row-item .item-value {
            font-size:12px;
            padding-top:2px;
            word-break: break-all;
        }
    .coindetail .row-list.last {
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/coindetail.vue